import React, { CSSProperties, useEffect, useState } from 'react'
import cx from 'classnames'

const useAnimate = (props: {
  fromClasses: string
  toClasses: string
  show: boolean
  durationMs: number
}): { className: string; style: CSSProperties } => {
  const [visible, setVisible] = useState(false)

  const className = cx('transition-all', {
    [props.fromClasses]: !props.show,
    [props.toClasses]: props.show,
    invisible: !visible,
    visible,
  })

  useEffect(() => {
    if (props.show) {
      setVisible(true)
    } else {
      setTimeout(() => setVisible(false), props.durationMs)
    }
  }, [props.show])

  const style = { transitionDuration: `${props.durationMs}ms` }
  return { className, style }
}

export default useAnimate
